export default "__VITE_ASSET__21ebed88__"